(function () {
    let clientWidth = window.document.documentElement.clientWidth
    // if (clientWidth > 1024) {
        document.documentElement.style.fontSize=16+'px'
    // } else {
        // document.documentElement.style.fontSize=10+'px'
    // }
})()
